import { cn } from "@/lib/utils";

interface AnswerSynthesisEmptyProps {
  className?: string;
}

export function AnswerSynthesisEmpty({ className }: AnswerSynthesisEmptyProps) {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M22 28 Q22 20 30 20 L90 20 Q98 20 98 28 L98 72 Q98 80 90 80 L46 80 L34 94 L34 80 L30 80 Q22 80 22 72 Z"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <polyline
        points="42,50 52,62 78,38"
        style={{ stroke: "hsl(var(--status-allow))" }}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
